import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FilterService } from '../filter/filter.service';
import { CurrencyService } from '../shared/currency.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '../shared/analytics/analytics.service';
import { UserService } from '../shared/user/user.service';
import { UrlService } from '../shared/url.service';
import { User } from '../shared/user/user.model';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  mobileMenuIsOpen: boolean = false;
  user: User = this.userService.getUser();
  currency: string = this.currencyService.getCurrency();

  //@Output() isReport = new EventEmitter<boolean>();

  constructor(
    public filterService: FilterService,
    public currencyService: CurrencyService,
    public analyticsService: AnalyticsService,
    public userService: UserService,
    public urlService: UrlService,
    private router: Router
  ) { }

  // onMainTitleClick(newState){
  //   this.isReport.emit(newState);
  // }

  getMyCullenUrl(): string {
    return this.urlService.getClientSiteUrl();
  }

  disableScrolling() {
    var x = window.scrollX;
    var y = window.scrollY;
    window.onscroll = function () { window.scrollTo(x, y); };
  }

  enableScrolling() {
    window.onscroll = function () { };
  }

  openMobileMenuOnClick() {
    this.mobileMenuIsOpen = true;
    this.disableScrolling();
  }

  closeMobileMenuOnClick() {
    this.mobileMenuIsOpen = false;
    this.enableScrolling();
  }

  logout() {
    this.userService.logOut();
  }

  // showLicencesTabMobile(){
  //   return !this.router.url.includes('licences');
  // }
  //
  // showAwardsTabMobile(){
  //   return !this.router.url.includes('awards');
  // }

  // onClickLicencesTabMobile(){
  //   console.log(this.router.url);
  //   console.log(this.router.routerState.snapshot.root);
  //   this.router.navigate([newUrl]);
  // }
  //
  // onClickAwardsTabMobile(){
  //     console.log(this.router.url);
  //     console.log(this.router.routerState.snapshot.root);
  //     this.router.navigate([newUrl]);
  // }

  ngOnInit() {
  }

}
